import { useCallback } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";
export default function useSetOkuriList() {
  const queryClient = useQueryClient();
  const { data: okuriList }: any = useQuery(queryKeys.okuriList, () =>
    queryClient.getQueryData(queryKeys.okuriList)
  );
  const setOkuriList = useCallback(
    (okuriList: any[]) =>
      queryClient.setQueryData(queryKeys.okuriList, okuriList),
    [queryClient]
  );

  return { okuriList: okuriList || [], setOkuriList };
}
